import * as ClipboardJS from 'clipboard';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export function statusPage(customer: any) {
  document.addEventListener('alpine:initialized', () => {
    new Swiper(document.getElementById('remained-steps'), {
      slidesPerView: 1.4,
      spaceBetween: 20,
      loop: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      modules: [Navigation],
    });
  });

  return {
    customer: JSON.parse(decodeURIComponent(customer)),
    currentTab: 0,
    expertsTab: 0,

    get remainedDays() {
      switch (this.customer.state) {
        case '(법)법무사접수':
          return 4;
        case '(법)자료수취':
          return 4;
        case '(법)공과금입금':
          return 3;
        case '(법)등기소접수':
          return 3;
        case '(법)법인설립완료':
          return 0;
      }
    },

    get currentStep() {
      switch (this.customer.state) {
        case '(법)법무사접수':
          return 1;
        case '(법)자료수취':
          return 2;
        case '(법)공과금입금':
          return 3;
        case '(법)등기소접수':
          return 4;
        case '(법)법인설립완료':
          return 5;
      }
    },
  };
}

export function init() {
  const clipboard = new ClipboardJS('.clipboard');

  clipboard.on('success', function () {
    alert('복사되었습니다.');
  });
}
